"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalStatusEnum = void 0;
var ApprovalStatusEnum;
(function (ApprovalStatusEnum) {
    ApprovalStatusEnum["NOT_STARTED"] = "NOT_STARTED";
    ApprovalStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    ApprovalStatusEnum["APPROVED"] = "APPROVED";
    ApprovalStatusEnum["REJECTED"] = "REJECTED";
    ApprovalStatusEnum["SKIPPED"] = "SKIPPED";
})(ApprovalStatusEnum || (exports.ApprovalStatusEnum = ApprovalStatusEnum = {}));
